import { type Page } from '#shared/api/schema';

export const getVisibleConstructorPages = (pages: Page[], pageAliasBlacklist: string[]): Page[] => {
    if (pageAliasBlacklist.length === 0) {
        return pages;
    }

    const blacklistSet = new Set(pageAliasBlacklist);

    return pages.filter((page) => !page.alias || !blacklistSet.has(page.alias));
};
